import styled from "styled-components";
import { ButtonBase, Typography } from "@mui/material";

export const Title = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;    
  }`;

export const Subtitle = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;       
  }`;


export const CTAButton = styled(ButtonBase)`&& {
    width: 175px;
    height: 50px;
    background: #f2753b;
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
  }`;